import { CHANNEL_TYPES, WIDGET_STATUS } from "./constants";
import { channelSlug } from "./feedbackService";

export const SETUP_STEP_KEYS = [
  "api",
  "widget",
  "active",
  "web_embed",
  "slug",
  "snippet",
  "cdn",
];

/** Steps counted in "X / 6 complete" progress (CDN is informational only). */
export const TRACKED_SETUP_STEPS = [
  "api",
  "widget",
  "active",
  "web_embed",
  "slug",
  "snippet",
];

export function computeVoiceCaptureSetupSteps(widget, { apiReady = true } = {}) {
  const webEmbedOn = (widget?.channels || []).some(
    (c) => c.channel_type === CHANNEL_TYPES.WEB_EMBED && c.enabled,
  );
  const embedSlug =
    widget && channelSlug(widget, CHANNEL_TYPES.WEB_EMBED);

  return {
    api: apiReady,
    widget: !!widget?.id,
    active: widget?.status === WIDGET_STATUS.ACTIVE,
    web_embed: !!webEmbedOn,
    slug: !!embedSlug,
    snippet: !!embedSlug && webEmbedOn && widget?.status === WIDGET_STATUS.ACTIVE,
    cdn: true,
  };
}

export function setupProgress(steps) {
  const tracked = TRACKED_SETUP_STEPS.filter((k) => steps[k] !== null);
  const done = tracked.filter((k) => steps[k] === true).length;
  return { done, total: tracked.length };
}
